export const isValidEmail = (email: string): boolean => {
    const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
};

export const hasEmail = (email?: string): boolean => typeof email === 'string' && email.length > 0;

export const hasExtUserId = (extUserId?: string): boolean => typeof extUserId === 'string' && extUserId.length > 0;
